<template>
  <v-carousel
    v-bind="$attrs"
    v-on="$listeners"
    :show-arrows="!$vuetify.breakpoint.xs"
    hide-delimiter-background
    :hide-delimiters="true"
    height="100%"
    width="100%"
  >
    <v-carousel-item
      :src="picture.medium"
      v-for="(picture, i) in this.pictures"
      :key="i"
      :link="link ? true : false"
      :href="link"
      target="_blank"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "BaseCarousel",
  props: {
    pictures: {
      type: Array,
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return !!value.length;
      }
    },
    link: {
      type: String,
      default: () => ""
    }
  }
};
</script>
